import ResizablePanel from 'components/Panel/ResizablePanel';
import React, { useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setActiveLeftPanelTab, setLeftPanelWidth } from 'redux/mode/actions';
import { LeftPanelTab } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';
import * as Base from '../styles';
import Chats from './Chats';
import DesignSystem from './DesignSystem';
import FrameList from './FrameList';
import TabBar from './TabBar';
import * as S from './styles';

const LeftPanel = () => {
	const dispatch = useDispatch();
	const ref = useRef() as React.MutableRefObject<HTMLDivElement>;

	const { leftPanelWidths, activeLeftPanelTab } = useSelector((r: RootReducer) => {
		return {
			leftPanelWidths: r.mode.leftPanelWidths,
			activeLeftPanelTab: r.mode.activeLeftPanelTab,
		};
	}, shallowEqual);
	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<ResizablePanel
			resizeOnSide="right"
			size={leftPanelWidths[activeLeftPanelTab]}
			onResize={(w) => {
				dispatch(setLeftPanelWidth({ tab: activeLeftPanelTab, width: w }));
			}}
		>
			<Base.Base ref={ref}>
				<S.Top>
					<TabBar
						labels={Object.values(LeftPanelTab)}
						activeLabel={activeLeftPanelTab}
						onChange={(tab) => dispatch(setActiveLeftPanelTab(tab as LeftPanelTab))}
					/>
				</S.Top>
				<Base.Divider />
				{activeLeftPanelTab === LeftPanelTab.CHAT && <Chats />}
				{activeLeftPanelTab === LeftPanelTab.DOCUMENT && <FrameList />}
				{activeLeftPanelTab === LeftPanelTab.DESIGN_SYSTEM && <DesignSystem />}
			</Base.Base>
		</ResizablePanel>
	);
};

export default LeftPanel;
